<div class="row my-2 scoreclass-changes-container">
  <div class="col-12">
    <mat-accordion>
      <mat-expansion-panel #benchmarkAccordion>
        <mat-expansion-panel-header
          [matTooltip]="description"
          [matTooltipClass]="'benchmarking-tooltip'"
        >
          <mat-panel-title> {{ label }} </mat-panel-title>
          <mat-panel-description>
            @if (!loading && benchmarkAccordion.expanded) {
              Click to hide firm average/benchmark
            } @else if (!loading && !benchmarkAccordion.expanded) {
              Click to show firm average/benchmark
            } @else if (loading) {
              Loading firm average/benchmark
            }
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="benchmark-table-container py-2">
          @if (benchmarkData.length && !loading) {
            <table class="w-100">
              <thead>
                @for (header of tableHeaders(benchmarkData); track header) {
                  <th>{{ header }}</th>
                }
              </thead>
              <tbody>
                @for (benchmark of benchmarkData; track benchmark) {
                  <tr>
                    @for (header of tableHeaders(benchmarkData); track header) {
                      <td>{{ benchmark[header] }}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          } @else if (!benchmarkData.length && !loading) {
            <div class="no-data"> No Data Found </div>
          } @else if (loading) {
            <ngx-loading
              [show]="loading"
              [config]="{ fullScreenBackdrop: false }"
            ></ngx-loading>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
